import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { crearCaso, CrearCasoRequest, EntidadTipo } from '../../api/mejoraCU2Api';

interface Props {
  open: boolean;
  prefill?: Partial<CrearCasoRequest>;
  onClose: () => void;
  onCreated: (id: number) => void;
}

const TIPOS: EntidadTipo[] = ['Farmacia', 'Farmaceutico', 'Transmision', 'Empleado', 'Traslado', 'Incidencia'];

const CrearCasoModal: React.FC<Props> = ({ open, prefill, onClose, onCreated }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  // Re-aplica el prefill cada vez que se abre (evita arrastrar datos del caso anterior)
  useEffect(() => {
    if (open) form.setFieldsValue({ prioridad: 'Media', ...prefill });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const submit = async () => {
    const values = await form.validateFields();
    setSaving(true);
    try {
      const caso = await crearCaso({
        entidadTipo: values.entidadTipo,
        entidadRefId: Number(values.entidadRefId),
        reconciliacionId: prefill?.reconciliacionId,
        titulo: values.titulo,
        descripcion: values.descripcion,
        prioridad: values.prioridad,
      });
      message.success(`Caso de mejora CU2 abierto (${caso.codigo})`);
      form.resetFields();
      onCreated(caso.id);
    } catch (e: any) {
      message.error(e?.response?.data?.error ?? 'No se pudo crear el caso');
    } finally { setSaving(false); }
  };

  return (
    <Modal open={open} title="Abrir caso Mejora CU2" onCancel={onClose} onOk={submit} confirmLoading={saving} okText="Crear" destroyOnClose>
      <Form form={form} layout="vertical" initialValues={{ prioridad: 'Media', ...prefill }}>
        <Form.Item name="entidadTipo" label="Entidad" rules={[{ required: true }]}>
          <Select options={TIPOS.map(t => ({ value: t, label: t }))} />
        </Form.Item>
        <Form.Item name="entidadRefId" label="ID del registro" rules={[{ required: true }]}>
          <Input type="number" />
        </Form.Item>
        <Form.Item name="titulo" label="Título" rules={[{ required: true, max: 200 }]}>
          <Input />
        </Form.Item>
        <Form.Item name="descripcion" label="Descripción" rules={[{ required: true }]}>
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item name="prioridad" label="Prioridad">
          <Select options={['Alta', 'Media', 'Baja'].map(p => ({ value: p, label: p }))} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CrearCasoModal;
